import React from 'react';
import styled from 'styled-components';
import Splash from '../../shared/Splash';
import Footer from '../../shared/Footer';
import Helmet from 'react-helmet';
import img from '../../../assets/banner.jpg';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export default function NoMatch() {
  return (
    <Wrapper>
      <Helmet
        title="AchieveCE | 404 Not Found"
        meta={[
          { name: 'description', content: 'Home Page for AchieveCE' },
          { property: 'og:type', content: 'website' },
          { property: 'og:title', content: 'Approved professional learning' },
          { property: 'og:url', content: 'http://achievece.com' },
        ]}
      />
      <Splash id="noMatch" img={img} />

      <Footer />
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/NoMatch/NoMatch.jsx